import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const aproveSelector = (state) =>
  state.authentication.userInfo.ApproveAcceptance;
const managerSelector = (state) =>
  state.authentication.userInfo.ManagerAcceptance;

export const useUserAcceptanceRole = () => {
  const approve = useSelector(aproveSelector);
  const manager = useSelector(managerSelector);

  return useMemo(() => {
    const status = approve ? 'director' : manager ? 'manager' : 'reader';

    return {
      status,
      isDirector: status === 'director',
      isManager: status === 'manager',
      isReader: status === 'reader',
      isDirectorOrManager: status === 'director' || status === 'manager',
    };
  }, [approve, manager]);
};
